import styled from 'styled-components';

export const LaunchButtonWrapper = styled.div`
  padding: 0 40px 40px;
`;
